async function fetchGoPuffVariants(variantSkus) {
  const deliveryLocation = JSON.parse(window.localStorage.getItem('delivery_location'));
  const params = {
    country_code: deliveryLocation.delivery_zone.country_code,
    location_id: deliveryLocation.delivery_zone.id,
    product_ids: variantSkus.join(','),
  };

  return fetch(`${window.gopuffShopify.settings.api_base_url}/products?${new URLSearchParams(params)}`)
    .then((response) => response.json())
}

async function updateAlchemyProductData() {
  const deliveryLocation = JSON.parse(window.localStorage.getItem('delivery_location'));
  if (!deliveryLocation || !window.alchemy?.features?.store?.products || !window.alchemy?.features?.store?.products?.length || !window.alchemy?.reload) {
    return;
  }
  const alchemyProducts = window.alchemy.features.store.products;
  const variantSkus = alchemyProducts.map((product) => product.variants.map(variant => variant.sku)).flat();
  const goPuffVariants = await fetchGoPuffVariants(variantSkus).then(({ products }) => products);
  const mappedProducts = alchemyProducts.map((product) => {
    let isAnyVariantAvailable = false;
    product.variants = product.variants.map((variant) => {
      const matchingGoPuffVariant = goPuffVariants.find(({ id }) => String(id) == String(variant.sku));
      if (matchingGoPuffVariant) {
        const goPuffVariantAvailability = matchingGoPuffVariant.quantity > 0;
        isAnyVariantAvailable = isAnyVariantAvailable || goPuffVariantAvailability
        return {
          ...variant,
          available: goPuffVariantAvailability,
          quantity: matchingGoPuffVariant.quantity,
        };
      }
      isAnyVariantAvailable = isAnyVariantAvailable || variant.available;
      return variant;
    })
    return { ...product, available: isAnyVariantAvailable };
  })
  window.alchemy.features.store.products = mappedProducts;
  window.alchemy.reload();
}


window.addEventListener('load', updateAlchemyProductData);

subscribe(PUB_SUB_EVENTS.deliveryLocationUpdate, updateAlchemyProductData);